var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuditLogIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.83999 1.33334H11.1533C11.5867 1.33334 11.9733 1.34669 12.32 1.39336C14.1667 1.60003 14.6667 2.46668 14.6667 4.84002V9.05336C14.6667 11.4267 14.1667 12.2933 12.32 12.5C11.9733 12.5467 11.5933 12.56 11.1533 12.56H4.83999C4.40665 12.56 4.01999 12.5467 3.67332 12.5C1.82665 12.2933 1.32666 11.4267 1.32666 9.05336V4.84002C1.32666 2.46668 1.82665 1.60003 3.67332 1.39336C4.01999 1.34669 4.40665 1.33334 4.83999 1.33334Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.05334 5.54669H11.5067",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.49335 9.40668H4.50667H11.5133",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66669 14.6667H11.3334",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.79647 5.53335H4.80246",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99636 5.53335H7.00235",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuditLogIcon);
export default __webpack_public_path__ + "static/media/audit-log-icon.0cfb03d70f517e674568d897412c70bd.svg";
export { ForwardRef as ReactComponent };